import { ProductAbbreviations, ProductType } from '@/creditflowresearch/domain/Product/types/ProductType';

export const LM_PRODUCT_ID = 'e2e0fb50-4a15-4503-853a-4bcbf94361d7';

export const ABS_PRODUCT_ID = 'df146e90-5edc-4182-9328-98cee1bd403b';
export const HYC_PRODUCT_ID = 'd74c0c41-aa65-4870-92c4-d9e6eb377802';
export const IGC_PRODUCT_ID = '837f88ba-b7cc-4f94-ad79-898d2d28148f';

export const ABS_ABBREVIATION = ProductAbbreviations.ABS;
export const HYC_ABBREVIATION = ProductAbbreviations.HYC;
export const IGC_ABBREVIATION = ProductAbbreviations.IGC;
export const LM_ABBREVIATION = ProductAbbreviations.LM;

export const ABS_TYPE = ProductType.ABS;
export const HYC_TYPE = ProductType.HYC;
export const IGC_TYPE = ProductType.IGC;
export const LM_TYPE = ProductType.LM;

export const ProductAbbreviationById = {
  [ABS_PRODUCT_ID]: ABS_ABBREVIATION,
  [HYC_PRODUCT_ID]: HYC_ABBREVIATION,
  [IGC_PRODUCT_ID]: IGC_ABBREVIATION,
} as const;

export const ProductIdByAbbreviation = {
  [ABS_ABBREVIATION]: ABS_PRODUCT_ID,
  [HYC_ABBREVIATION]: HYC_PRODUCT_ID,
  [IGC_ABBREVIATION]: IGC_PRODUCT_ID,
  [LM_ABBREVIATION]: LM_PRODUCT_ID,
} as const;

export const ProductIdToTypeMap: Record<string, ProductType> = {
  [ABS_PRODUCT_ID]: ABS_TYPE,
  [HYC_PRODUCT_ID]: HYC_TYPE,
  [IGC_PRODUCT_ID]: IGC_TYPE,
  [LM_PRODUCT_ID]: ProductType.LM,
} as const;

export const ProductAbbreviationToTypeMap: Record<string, ProductType> = {
  [ABS_ABBREVIATION]: ABS_TYPE,
  [HYC_ABBREVIATION]: HYC_TYPE,
  [IGC_ABBREVIATION]: IGC_TYPE,
  [LM_ABBREVIATION]: LM_TYPE,
} as const;

export const ProductSortOrder = {
  [ABS_ABBREVIATION]: 0,
  [HYC_ABBREVIATION]: 1,
  [IGC_ABBREVIATION]: 2,
  [LM_ABBREVIATION]: 3,
} as const;
